import ServicesApi from "../api/services_api";
import {Link} from "react-router-dom";
import React from "react";
import {MotionAnimate} from "react-motion-animate";
import {useTranslation} from "react-i18next";

function SectionServices(props) {

    const { t, i18n } = useTranslation()

    return <div>
        <section id={'services'} className={'min-vh-100'}>

            <div className="p-md-5 p-2 text-center">

                <div id={'whtat-todo__title-position'} className="p-md-5 p-3">
                    <small className="text-secondary">
                        {/*software developer*/}
                        {t('nav.work')}
                    </small>

                    <h2 className={'display-1'}>
                        {props.title}
                        {/*{props.subTitle}*/}
                    </h2>

                </div>

                <div className="d-flex flex-wrap align-items-center justify-content-around mt-5 pt-5">

                    <div className="col-md-4 col-12">
                        <MotionAnimate
                            animation='fadeInUp'
                            reset={true}
                            distance={200}
                            delay={1}
                            speed={1.5}>
                            <h2 className="opacity-25 display-1">
                                {'Web develop'}
                            </h2>
                            <div className="text-start p-3">
                                <p className={'opacity-50'}>
                                    Веб розробка — процес створення вебсайтів або вебдодатків. Основними етапами процесу є вебдизайн, верстка сторінок, програмування для веб на стороні клієнта і сервера, а також конфігурування вебсервера.
                                </p>
                                <Link to={'/s/web-dev'} className={'nav-link'}>
                                    {t('know.more')} <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                                          className="bi bi-arrow-up-right-square-fill m-1" viewBox="0 0 16 16">
                                    <path
                                        d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zM5.904 10.803 10 6.707v2.768a.5.5 0 0 0 1 0V5.5a.5.5 0 0 0-.5-.5H6.525a.5.5 0 1 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 .707.707"/>
                                </svg>
                                </Link>
                            </div>
                        </MotionAnimate>
                    </div>
                    <div className={`col-md-4 col-12`}>
                        <MotionAnimate
                            animation='fadeInUp'
                            reset={true}
                            distance={200}
                            delay={1}
                            speed={1.3}>
                            <Link to={''} target={'_blank'} className={'text-decoration-none'}>
                                <img
                                    src={'https://cdn.prod.website-files.com/642d682a6e4ca0d303c81fdf/65ce102c339e344ef683c6a4_MacBook%20Pro%20and%20iPhone%2015%20Pro%20Mockup.webp'}
                                    alt="macbook-and-iphone" className={'img-fluid'}/>
                            </Link>
                        </MotionAnimate>
                    </div>
                    <div className="col-md-4 col-12">
                        <MotionAnimate
                            animation='fadeInUp'
                            reset={true}
                            distance={200}
                            delay={1}
                            speed={1.5}>

                            <h2 className="opacity-25 display-1">
                                {'Mobile develop'}
                            </h2>
                            <div className="text-start p-3">
                                <p className={'opacity-50'}>
                                    Розробка застосунків для мобільних пристроїв — це процес, при якому застосунки розробляються для невеликих портативних пристроїв, таких як смартфони або планшети. Ці програми можуть бути завантажені користувачем з допомогою різних платформ для поширення або бути вебзастосунками, які обробляються на стороні клієнта або сервера.
                                </p>
                                <Link to={'/s/mobile-dev'} className={'nav-link'}>
                                    {t('know.more')} <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                                          className="bi bi-arrow-up-right-square-fill m-1" viewBox="0 0 16 16">
                                    <path
                                        d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zM5.904 10.803 10 6.707v2.768a.5.5 0 0 0 1 0V5.5a.5.5 0 0 0-.5-.5H6.525a.5.5 0 1 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 .707.707"/>
                                </svg>
                                </Link>
                            </div>
                        </MotionAnimate>
                    </div>

                </div>

                <div className="text-end p-5">
                    <Link to="/cooperation" className={'text-decoration-none text-dark'}>
                        <b>{t('get.consultation')}</b>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                             className="bi bi-arrow-up-right-square-fill m-1" viewBox="0 0 16 16">
                            <path
                                d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zM5.904 10.803 10 6.707v2.768a.5.5 0 0 0 1 0V5.5a.5.5 0 0 0-.5-.5H6.525a.5.5 0 1 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 .707.707"/>
                        </svg>
                    </Link>
                </div>

            </div>

        </section>
    </div>;
}

export default SectionServices;
